import React, { memo } from 'react'
import { faArrowsRotate } from '@fortawesome/pro-duotone-svg-icons'

import FaIcon from '../faIcon/FaIcon'
import Button from './Button'

const RefreshButton = ({ t, ...restProps }) => {
  return (
    <Button
      label={t('common.refresh')}
      endIcon={<FaIcon icon={faArrowsRotate} />}
      variant='outlined'
      {...restProps}
    />
  )
}

export default memo(RefreshButton)
